import {
  orderTypeLabels,
  PurchaseOrderOrderTypeEnum,
} from "@/features/purchase-orders";
import {
  Paper,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { SelectLabSalesRequestSection } from "./select-lab-sales-request-section";
import { SelectStandardSalesRequestSection } from "./select-standard-sales-request-section";

export const SelectSalesRequestSection = () => {
  const [orderType, setOrderType] = useState(
    PurchaseOrderOrderTypeEnum.STANDARD
  );

  const handleOrderTypeChange = (_, newMode) => {
    if (newMode !== null) {
      setOrderType(newMode);
    }
  };

  return (
    <Paper sx={{ p: 2.5, borderRadius: 2 }}>
      <Stack spacing={2.5}>
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "center"
          }}>
          <Typography variant="h6">Ambil Permintaan Penjualan</Typography>
          <ToggleButtonGroup
            exclusive
            size="small"
            value={orderType}
            onChange={handleOrderTypeChange}
          >
            <ToggleButton value={PurchaseOrderOrderTypeEnum.STANDARD}>
              {orderTypeLabels[PurchaseOrderOrderTypeEnum.STANDARD]}
            </ToggleButton>
            <ToggleButton value={PurchaseOrderOrderTypeEnum.LAB}>
              {orderTypeLabels[PurchaseOrderOrderTypeEnum.LAB]}
            </ToggleButton>
          </ToggleButtonGroup>
        </Stack>
        {orderType === PurchaseOrderOrderTypeEnum.STANDARD ? (
          <SelectStandardSalesRequestSection />
        ) : (
          <SelectLabSalesRequestSection />
        )}
      </Stack>
    </Paper>
  );
};
